import { useEffect } from 'react';
import { usePageTitle } from '@/hooks/usePageTitle';
import { PageHeader } from '@/components/ui/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { RoleTable } from '../components/RoleTable';
import { RoleAuthorizationsPanel } from '../components/RoleAuthorizationsPanel';
import { UserRolesTable } from '../components/UserRolesTable';
import { useAuthorizationStore } from '../store';

export function AuthorizationManagementPage() {
  usePageTitle('Authorization Management');
  const { roles, isLoadingRoles, rolesError, fetchRoles } = useAuthorizationStore();

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Authorization Management"
        description="Manage roles, permissions, and user role assignments"
      />
      <Tabs defaultValue="roles" className="space-y-4">
        <TabsList>
          <TabsTrigger value="roles">Role Management</TabsTrigger>
          <TabsTrigger value="authorizations">Role Authorizations</TabsTrigger>
          <TabsTrigger value="user-roles">User Roles</TabsTrigger>
        </TabsList>

        <TabsContent value="roles" className="space-y-4">
          {isLoadingRoles ? (
            <div className="flex items-center justify-center h-48">
              <div className="text-muted-foreground">Loading roles...</div>
            </div>
          ) : rolesError ? (
            <div className="flex items-center justify-center h-48">
              <div className="text-destructive">{rolesError}</div>
            </div>
          ) : (
            <RoleTable data={roles} />
          )}
        </TabsContent>

        <TabsContent value="authorizations" className="space-y-4">
          <RoleAuthorizationsPanel />
        </TabsContent>

        <TabsContent value="user-roles" className="space-y-4">
          <UserRolesTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
